{
  "version": 1,
  "asset_id": "56ba3a54-afb4-4da1-9421-f3cdaad68255",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/56ba3a54-afb4-4da1-9421-f3cdaad68255/cp508c.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/56ba3a54-afb4-4da1-9421-f3cdaad68255/cp508c.jpg",
  "original_filename": "cp508c.jpg",
  "size": 121776,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:32Z"
}
